import moment from 'moment'
import { mapState } from 'vuex'
import { deviceEnquire, DeviceType } from '@/utils/device'

const mixinDevice = {
    computed: {
        ...mapState({
            device: state => state.app.device
        })
    },
    methods: {
        isDesktop () {
            return this.device === DeviceType.desktop
        },
        isLaptop () {
            return this.device === DeviceType.laptop
        },
        isTablet () {
            return this.device === DeviceType.tablet
        },
        isVTablet () {
            return this.device === DeviceType.vtablet
        },
        isMobile () {
            return this.device === DeviceType.mobile
        }
    }
}

const AppDeviceEnquire = {
    mounted () {
        const { $store } = this
        deviceEnquire(deviceType => {
            switch (deviceType) {
            case DeviceType.desktop:
                $store.commit('ToggleDevice', 'desktop')
                break
            case DeviceType.laptop:
                $store.commit('ToggleDevice', 'laptop')
                break
            case DeviceType.tablet:
                $store.commit('ToggleDevice', 'tablet')
                break
            case DeviceType.vtablet:
                $store.commit('ToggleDevice', 'v-tablet')
                break
            case DeviceType.mobile:
            default:
                $store.commit('ToggleDevice', 'mobile')
                break
            }
        })
    }
}

const rangeDateFormatter = {
    methods: {
        formatedDate (date) {
            moment.locale(this.$root.lang, {
                months: this.$root.lang === 'ru'
                    ? ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря']
                    : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            })

            let start = {
                day: this.fixTimezone(date.start).format('D'),
                year: this.fixTimezone(date.start).format('YYYY'),
                month: this.fixTimezone(date.start).format('MMMM'),
                full: this.fixTimezone(date.start).format('D MMMM YYYY')
            }

            let end = {
                day: this.fixTimezone(date.end).format('D'),
                year: this.fixTimezone(date.end).format('YYYY'),
                month: this.fixTimezone(date.end).format('MMMM'),
                full: this.fixTimezone(date.end).format('D MMMM YYYY')
            }

            if (start.full === end.full) return `${start.day} ${start.month}, ${start.year}`
            if (start.full !== end.full) {
                if (start.year === end.year) {
                    if (start.month === end.month) {
                        if (start.day === end.day) {
                            return `${start.day} ${start.month}, ${start.year}`
                        } else {
                            return `${start.day} – ${end.day} ${start.month}, ${start.year}`
                        }
                    }
                    if (start.month !== end.month) {
                        return `${start.day} ${start.month} – ${end.day} ${end.month}, ${start.year}`
                    }
                } else {
                    return `${start.full} – ${end.full}`
                }
            }
        },
        fixTimezone (date) {
            return moment.unix(date).utc().add(3, 'hours')
        }
    }
}

const gRecaptcha = {
    data () {
        return {
            gKey: '6LfyS74iAAAAAATZNMqmPUAnY1CZ2pXchfzpmZID'
        }
    },
    created () {
        this.initGRecaptcha()
    },
    methods: {
        initGRecaptcha () {
            const script = document.createElement('script')

            script.async = true
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.gKey}`

            document.head.appendChild(script)
        }
    }
}

const maxLengthString = {
    methods: {
        maxLengthString (name, max) {
            return name.length > max
        }
    }
}

const filterSize = {
    methods: {
        filterSize (value) {
            let numberSize = value.replace(/[a-zа-яё]/gi, '')
            let typeSize = value.replace(/[^a-zа-яё]/gi, '')
            let size = `${this.numberFilter(numberSize, { millesimal: ',', decimal: '.' })} ${typeSize}`

            return size
        },
        numberFilter (dataStr, options = {}) {
            let settings = {
                locale: this.$root.lang === 'ru' ? 'ru-RU' : 'en-EN',
                millesimal: '',
                decimal: '.'
            }
            settings = {...settings, ...options}

            let result = dataStr.toString().replace(' ', '')
            result = result.replace(new RegExp(settings.millesimal, 'g'), '')
            result = result.replace(new RegExp(`[${settings.decimal}]`, 'g'), '.')
            result = Number(result)

            if (isNaN(result)) return dataStr

            return result.toLocaleString(settings.locale)
        }
    }
}

export { mixinDevice, AppDeviceEnquire, rangeDateFormatter, gRecaptcha, maxLengthString, filterSize }
